import { createContext, useContext } from 'react';

import { SignupFormContextValue } from './types';

export const SignupFormContext = createContext<SignupFormContextValue>({});

export const useAdditionalInformation = () => {
  const { additionalInformation, setAdditionalInformation } = useContext(SignupFormContext);
  if (!setAdditionalInformation) {
    throw new Error('Use this hook within the SignupFormContext provider');
  }
  return { additionalInformation, setAdditionalInformation };
};

export const useWorkingInformation = () => {
  const { workingInformation, setWorkingInformation } = useContext(SignupFormContext);
  if (!setWorkingInformation) {
    throw new Error('Use this hook within the SignupFormContext provider');
  }
  return { workingInformation, setWorkingInformation };
};

export const useUserInformation = () => {
  const { userInformation, setUserInformation } = useContext(SignupFormContext);
  if (!setUserInformation) {
    throw new Error('Use this hook within the SignupFormContext provider');
  }
  return { userInformation, setUserInformation };
};

export const useSubscribedPro = () => {
  const { subscribedPro, setSubscribedPro } = useContext(SignupFormContext);
  if (!setSubscribedPro) {
    throw new Error('Use this hook within the SignupFormContext provider');
  }
  return { subscribedPro, setSubscribedPro };
};

export const useRevenueSimulatorInformation = () => {
  const { revenueSimulator, setRevenueSimulator } = useContext(SignupFormContext);
  if (!setRevenueSimulator) {
    throw new Error('Use this hook within the SignupFormContext provider');
  }
  return { revenueSimulator, setRevenueSimulator };
};

export const useUniverse = () => {
  const { universe, setUniverse } = useContext(SignupFormContext);
  if (!setUniverse) {
    throw new Error('Use this hook within the SignupFormContext provider');
  }
  return { universe, setUniverse };
};
